import { onsiteItems } from '@/mocks/homeData';

export default function OnsiteFeed() {
  return (
    <section id="onsite" className="w-full bg-background-100 px-4 py-16 md:px-8 md:py-24">
      <div className="mx-auto w-full max-w-7xl">
        <div data-reveal className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-900 px-3 py-1.5 text-xs font-medium text-background-100 md:text-sm">
            <i className="ri-camera-lens-line" />
            <a href="#onsite" className="cursor-pointer hover:text-accent-300">
              现场爆料
            </a>
          </span>
          <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-4xl">
            图文并重，跟着时间线看现场
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            每一组都按地点和时间排列，图在前、文字在后。先看画面里能确认的部分，再看我们整理的要点，
            判断起来会轻松很多。
          </p>
        </div>

        <div className="mt-12 flex flex-col gap-8 md:gap-12">
          {onsiteItems.map((item, index) => {
            const reversed = index % 2 === 1;
            return (
              <article
                key={item.id}
                data-reveal
                className="grid grid-cols-1 items-center gap-6 rounded-lg border border-background-200 bg-background-50 p-4 md:gap-10 md:p-6 lg:grid-cols-2"
              >
                <div className={`relative h-60 w-full overflow-hidden rounded-lg bg-background-200 md:h-80 ${reversed ? 'lg:order-2' : ''}`}>
                  <img
                    src={item.image}
                    alt={item.title}
                    title={`${item.place} 现场爆料 黑料51`}
                    className="h-full w-full object-top"
                  />
                  <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
                    {item.tag}
                  </span>
                </div>

                <div className={reversed ? 'lg:order-1' : ''}>
                  <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500 md:text-sm">
                    <span className="flex items-center gap-1.5">
                      <i className="ri-map-pin-line" />
                      {item.place}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-time-line" />
                      {item.time}
                    </span>
                    <span className="flex items-center gap-1.5">
                      <i className="ri-eye-line" />
                      {item.heat}
                    </span>
                  </div>

                  <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-foreground-950 md:text-2xl">
                    {item.title}
                  </h3>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">{item.excerpt}</p>

                  <ul className="mt-5 space-y-2.5">
                    {item.bullets.map((bullet) => (
                      <li key={bullet} className="flex items-start gap-2.5 text-sm text-foreground-700">
                        <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                          <i className="ri-check-line text-[11px]" />
                        </span>
                        {bullet}
                      </li>
                    ))}
                  </ul>

                  <button
                    type="button"
                    className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-300 hover:bg-primary-50 cursor-pointer"
                  >
                    <i className="ri-bookmark-line" />
                    收藏这组现场
                  </button>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}